import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@portal/app/app.module';
import { environment } from '@portal/environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init({
    dsn: 'https://8c28b244614d385dbaaf58133a593d36@o4507861430501376.ingest.us.sentry.io/4507861436203008',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
      // Capture console logs and send to Sentry
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/portal\.measured\.com\//],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Set profileSessionSampleRate to 1.0 to profile every session.
    // The profiling decision is made once per session when the SDK is initialized.
    // Note: Requires Document-Policy: js-profiling header from server for full functionality.
    profileSessionSampleRate: 1.0
  });
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
